import Typography from '@mui/material/Typography'

const ModalHeaderTypography = ({ children, ...props }) => (
  <Typography
    component="h1"
    variant="h5"
    sx={{
      fontSize: { xs: '16px', md: '18px' },
      color: 'text.black',
      fontWeight: '600'
    }}
    {...props}
  >
    {children}
  </Typography>
)

export default ModalHeaderTypography
